export const environment = {
  production: false,
  scheme: "https://",
  host: "api-managment-digitalizcija.azure-api.net/vrc-api-development",
  auth_host: "api-managment-digitalizcija.azure-api.net/vrc-api-development",
  crm_host: "api-managment-digitalizcija.azure-api.net/vrc-api-development",
  offer_host: "api-managment-digitalizcija.azure-api.net/vrc-api-development",
  validation_host: "api-managment-digitalizcija.azure-api.net/vrc-api-development",
  port: "",
  version: 1,
  authVersion: 1,
  crmVersion: 1,
  offerVersion: 1,
  validationVersion: 1,
  app_url: 'https://vrc.dev.valamar.hr',
  web_url: 'https://www.valamar-preview.com',
  enableServiceWorker: false,
  theme: "theme-background-dev",
  env_text: "Development",
  msalConfig: {
    auth: {
      clientId: "d214182b-1be7-4e7e-b1ef-5c6436b86267",
      authority: "https://login.microsoftonline.com/c7223f2c-1ba2-43c8-be7f-57e6e1465036"
    },
    api:"c9ba2c97-dd7a-4d17-bc66-9e972a62328d/All.All"
  }
};
